<div class="dialog-content-max" *ngIf="!isView">
    <form [formGroup]="helpForm">

        <div class="formgrid grid">
            <div class="field col-4">
                <div class="form-group">
                    <label for="product" class="required-label">Product
                        <span style="color: rgb(60, 137, 246);font-size:9px !important;"></span><span>&nbsp;*</span>
                    </label>
                    <p-dropdown [options]="productList" inputId="product" formControlName="product"
                        placeholder="Select Product" optionLabel="productinitial" optionValue="productid"
                        [showClear]="true" appendTo="body" name="product" [filter]="true"
                        [resetFilterOnHide]="true"></p-dropdown>
                    <span class="errormessage"
                        *ngIf="helpForm.get('product').invalid && (helpForm.get('product').touched || helpForm.get('product').dirty) ">
                        {{getErrorMessage(helpForm,validation_message,'product')}}
                    </span>
                </div>
            </div>
            <!--
        <div class="field col-8">
        <div class="form-group">
        <label class="required-label" style="color:red">** If No product is selected , then By default it will save (.general)</label>
          </div></div>
          -->
        </div>

        <div class="formgrid grid">
            <div class="field col-11">
                <div class="form-group">
                    <label for="topic" class="required-label">Help Topic
                        <span style="color: rgb(60, 137, 246);font-size:9px !important;"> (Max 50 chars)</span><span>
                            *</span></label>
                    <input class="form-control" type="text" placeholder="Enter Help Topic" maxlength="50" id="topic"
                        formControlName="topic" name="topic" />
                    <span class="errormessage"
                        *ngIf="helpForm.get('topic').invalid && (helpForm.get('topic').touched  || helpForm.get('product').dirty)">
                        {{getErrorMessage(helpForm ,validation_message,'topic')}}
                    </span>
                </div>
            </div>
        </div>

        <div class="formgrid grid">
            <div class="field col-12">
                <div class="form-group">
                    <label for="webpage" class="required-label">Web Page
                        <span style="color: rgb(60, 137, 246);font-size:9px !important;"> (Max 200 chars)</span><span>
                            *</span></label>
                    <textarea placeholder="Enter Web Page" class="form-control" pInputTextarea [autoResize]="true"
                        formControlName="webpage" inputId="webpage" id="webpage" name="webpage">
            </textarea>
                    <span class="errormessage"
                        *ngIf="helpForm.get('webpage').invalid && (helpForm.get('webpage').touched  || helpForm.get('webpage').dirty)">
                        {{getErrorMessage(helpForm ,validation_message,'webpage')}}
                    </span>
                </div>
            </div>
        </div>

        <div class="formgrid grid">
            <div class="field col-4">
                <div class="form-group">
                    <label for="modulehelpid" class="required-label">Module Help ID
                        <span style="color: rgb(60, 137, 246);font-size:9px !important;"> (Max 4 digits)</span><span>
                            *</span></label>
                    <input class="form-control" type="number" placeholder="Enter Module Help ID" maxlength="4"
                        id="modulehelpid" formControlName="modulehelpid" name="modulehelpid" />
                    <span class="errormessage"
                        *ngIf="helpForm.get('modulehelpid').invalid && (helpForm.get('modulehelpid').touched  || helpForm.get('modulehelpid').dirty)">
                        {{getErrorMessage(helpForm ,validation_message,'modulehelpid')}}
                    </span>
                </div>
            </div>

            <div class="field col-4">
                <div class="form-group">
                    <label for="sequence" class="required-label">Sequence
                        <span style="color: rgb(60, 137, 246);font-size:9px !important;"> (Max 4 digits)</span><span>
                            *</span></label>
                    <input class="form-control" type="number" placeholder=" Sequence number" maxlength="4" id="sequence"
                        formControlName="sequence" name="sequence" />
                    <span class="errormessage"
                        *ngIf="helpForm.get('sequence').invalid && (helpForm.get('sequence').touched  || helpForm.get('sequence').dirty)">
                        {{getErrorMessage(helpForm ,validation_message,'sequence')}}
                    </span>
                </div>
            </div>

            <div class="field col-4">
                <div class="form-group">
                    <label for="adminflag" class="required-label">Admin Topic?<span>&nbsp;*</span></label>
                    <p-dropdown [options]="adminFlag" inputId="adminflag" appendTo="body" name="adminflag"
                        optionLabel="labelname" optionValue="value" formControlName="adminflag"
                        placeholder="Select Admin Flag" [showClear]="true"></p-dropdown>
                    <span class="errormessage"
                        *ngIf="helpForm.get('adminflag').invalid && (helpForm.get('adminflag').touched  || helpForm.get('adminflag').dirty)">
                        {{getErrorMessage(helpForm,validation_message,'adminflag')}}
                    </span>
                </div>
            </div>        
        </div>


        <div class="formgrid grid">
            <div class="field col-12">
                <div class="form-group">
                    <label for="helptext" class="required-label">Help Description<span
                            style="color: rgb(60, 137, 246);font-size:9px !important;"> (Max 64000
                            chars) </span><span> *</span></label>
                    <p-editor pInputTextarea class="form-control" type="text" placeholder="Enter Help Description"
                        formControlName="helptext" [readonly]="onlyView" name="helptext" maxlength="20000"
                        [style]="{ height: 'auto' }" />
                    <span class="errormessage"
                        *ngIf="helpForm.get('helptext').invalid && (helpForm.get('helptext').touched || helpForm.get('helptext').dirty)">
                        {{getErrorMessage(helpForm ,validation_message,'helptext')}}
                    </span>
                </div>
            </div>
        </div>


        <div class="formgrid grid" *ngIf="isEdit">
            <div class="field col-3" style="margin-bottom: 3rem;">
                <div class="form-group">
                    <label for="activeflag">Active Flag</label>
                    <p-dropdown [options]="activeFlag" inputId="activeflag" appendTo="body" name="activeflag"
                        optionLabel="labelname" optionValue="value" placeholder="Select Active Flag"
                        formControlName="activeflag"></p-dropdown>
                </div>
            </div>
        </div>
        <div class="custom-dialog-footer">
            <p-button class="m-1" label="Close" styleClass="customeclose" (click)="dismiss()"></p-button>
            <p-button class="m-1" *ngIf="!isView" label="{{saveTitle}}" styleClass="customesave"
                (click)="add()"></p-button>
        </div>
    </form>
</div>



<!----------------------- View Modal-->

<div class="dialog-content-max" *ngIf="isView">
    <form [formGroup]="helpForm">

        <div class="formgrid grid">

            <div class="field col-6">
                <div class="form-group">
                    <label for="product" class="required-label">Product</label>
                    <input type="text" class="form-control" formControlName="product" [readonly]="true" />
                </div>
            </div>
        </div>

        <div class="formgrid grid">
            <div class="field col-12">
                <div class="form-group">
                    <label for="topic" class="required-label">Help Topic</label>
                    <input type="text" class="form-control" formControlName="topic" [readonly]="true" />
                </div>
            </div>
        </div>

        <div class="formgrid grid">
            <div class="field col-12">
                <div class="form-group">
                    <label for="webpage" class="required-label">Web Page</label>
                    <input type="text" class="form-control" formControlName="webpage" [readonly]="true" />
                </div>
            </div>
        </div>

        <div class="formgrid grid">
            <div class="field col-4">
                <div class="form-group">
                    <label for="modulehelpid" class="required-label">Module Help ID</label>
                    <input type="text" class="form-control" formControlName="modulehelpid" [readonly]="true" />
                </div>
            </div>

            <div class="field col-4">
                <div class="form-group">
                    <label for="sequence" class="required-label">Sequence</label>
                    <input type="text" class="form-control" formControlName="sequence" [readonly]="true" />
                </div>
            </div>

            <div class="field col-4">
                <div class="form-group">
                    <label for="adminflag" class="required-label">Admin Topic?</label>
                    <input type="text" class="form-control" formControlName="adminflag" [readonly]="true" />
                </div>
            </div>
        </div>

        <div class="formgrid grid">
            <div class="field col-12">
                <label for="helptext" class="required-label">Help Description</label>
                <p-editor pInputTextarea class="form-control" type="text" formControlName="helptext"
                    [readonly]="onlyView" name="helptext" [style]="{ height: '200px' }" />
            </div>
        </div>

        <div class="formgrid grid">
            <div class="field col-3">
                <label for="activeflag">Active Flag</label>
                <input type="text" class="form-control" formControlName="activeflag" [readonly]="true" />
            </div>
        </div>

        <div class="custom-dialog-footer">
            <p-button class="m-1" label="Close" styleClass="customeclose" (click)="dismiss()"></p-button>
        </div>

    </form>

</div>